import React from 'react';
import IconWrapper from '../../../IconWrapper';
const MediaPlayIconMedium = (props) => (React.createElement(IconWrapper, { ...props },
    React.createElement("path", { d: "M2.493 1.138a1 1 0 0 1 .993-.012l18 10a1 1 0 0 1 0 1.748l-18 10A1 1 0 0 1 2 22V2a1 1 0 0 1 .493-.862ZM21 12 3 2v20l18-10Z" })));
export default MediaPlayIconMedium;
//# sourceMappingURL=MediaPlayIconMedium.js.map